import { reloadAppForUpdate, useAppVersionCheck } from '@shared/hooks/useAppVersionCheck';
import { useBottomBannerStore } from '@shared/stores/bottomBannerStore';
import { cn } from '@shared/utils/utils';
import { RefreshCw, X } from 'lucide-react';
import { useState } from 'react';
import { createPortal } from 'react-dom';

export function AppVersionChecker() {
  const { updateAvailable } = useAppVersionCheck();
  const [dismissed, setDismissed] = useState(false);
  const inactivityWarningVisible = useBottomBannerStore((state) => state.inactivityWarningVisible);

  if (!updateAvailable || dismissed) {
    return null;
  }

  return createPortal(
    <div
      className={cn(
        'pointer-events-auto fixed left-1/2 z-[9990] flex -translate-x-1/2 items-center gap-2',
        inactivityWarningVisible ? 'bottom-14' : 'bottom-4',
        'rounded-full border border-lines bg-card-bg px-3 py-1.5 shadow-md',
      )}
      data-testid="app-version-update-banner"
      role="status"
    >
      <RefreshCw className="h-3.5 w-3.5 shrink-0 text-subtext" aria-hidden="true" />
      <p className="text-xs text-subtext">
        Nueva versión disponible
        <span className="mx-1.5 text-lines">·</span>
        <button
          type="button"
          className="font-medium text-title underline-offset-2 transition-colors hover:text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          onClick={reloadAppForUpdate}
        >
          Actualizar
        </button>
      </p>
      <button
        type="button"
        aria-label="Ocultar aviso de actualización"
        className="ml-0.5 rounded-full p-0.5 text-subtext transition-colors hover:bg-hover-press hover:text-title focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        onClick={() => setDismissed(true)}
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>,
    document.body,
  );
}
